"use strict";

exports.__esModule = true;
exports.CreatorSection = CreatorSection;
var _react = _interopRequireDefault(require("react"));
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _excluded = ["creator"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function CreatorSection(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var creator = props.creator,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, _extends({}, extra, {
    heading: translate("TicketDetailsEditForm.creator", "Creator"),
    content: creator
  }));
}